import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';

@Entity('modele_courriel')
export class ModeleCourriel {
    static key = 'modele-courriel';

    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    name: string;

    @Column({ nullable: true })
    title: string;

    @Column({ nullable: true })
    body: string;
}
